import React from 'react';
import { Link } from 'react-router-dom'

import Redo from '../App/Redo';
import Banner from '../App/Banner';

import DropShippingFR from '../../assets/categories/DropFR.PNG'
import Check from '../../assets/check.svg'
import Arrow from '../../assets/arrow.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function IOSS() {
  return(
    <div>
      <Banner />
      <div id="IOSS" className='paper'>

      <Link to='/MarketPlace'>
        <button className="return">
        <img src={GreyArrow} alt="fleche grise"/>
          Retour
        </button>
      </Link>

      <div className="breadcrumbs">
        <p><img src={Check} />Votre stock se situe hors Union Européenne</p>
        <p><img src={Check} />La valeur de la marchandise est inférieure à 150 €</p>
        <p><img src={Check} />Vous ne passez pas par une plateforme facilitatrice</p>
      </div>

      <h4>La procédure :</h4>
      <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Appliquez le taux de TVA du pays de destination</ul>
      <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Déclarez la TVA  chaque mois sur le guichet unique IOSS</ul>
      <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Vous avez l’obligation de tenir un registre des ventes (à conserver 10 ans)</ul>
      <hr />

      <div className="when">
        <h5>Quand s’inscrire au guichet unique IOSS ?</h5>
        <p>Avant la première vente, afin de pouvoir communiquer le n°IOSS à vos fournisseurs.
        <br />Cela vous évitera de payer la TVA à l’importation</p>
      </div>

        <hr />

        <div className='categorie' >
          <h3>Si vous êtes client Dougs:</h3>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez la catégorie ci-dessous</ul>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez le pays de destination</ul>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />La TVA se calcule automatiquement</ul>
          <img src={DropShippingFR} alt="Categorie dropshipping" />
        </div>

        <div className="button">
          <Redo />
        </div>
      </div>
    </div>
  )
}

export default IOSS